import React from 'react'

import styled from '@emotion/styled'
import {
  AlignItems,
  Body3,
  Box,
  Color,
  Display,
  FlexDirection,
  Heading4,
  Heading6,
  TextAlign,
} from '@gousto-internal/citrus-react'

import { config } from './config'

interface Props {
  isYourOffer: boolean
  offer: string
  theirMonthOffer?: string
  discountDuration?: string
  secondBoxDiscount?: string
}

const OfferContainer = styled(Box)`
  border-radius: 4px;
  text-align: center;
  width: 50%;
`

export const Offer: React.FC<Props> = ({
  isYourOffer,
  offer,
  theirMonthOffer,
  discountDuration,
  secondBoxDiscount,
}) => {
  const offerConfig = config(theirMonthOffer, discountDuration, secondBoxDiscount)
  const title = isYourOffer ? offerConfig.youGetTitle : offerConfig.yourFriendGetsTitle
  const description = isYourOffer
    ? offerConfig.youGetDescription
    : offerConfig.yourFriendGetsDescription

  return (
    <OfferContainer
      paddingH={3}
      paddingV={3}
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      alignItems={AlignItems.Center}
      gap={1}
    >
      <Heading6 textAlign={TextAlign.Center}>{title}</Heading6>
      <Heading4>{offer}</Heading4>
      <Body3 color={Color.ColdGrey_800} textAlign={TextAlign.Center}>
        {description}
      </Body3>
    </OfferContainer>
  )
}
